export class HubMessageEvent extends Event {
  data: string;

  minVersion: string;

  connectingVersion: string;

  reason: string;
}
